import React from "react";
import { Flex, Box } from "grid-styled";
import { gql } from "apollo-boost";
import { graphql, compose } from "react-apollo";
import FranchiseInfoCard from "./FranchiseInfoCard";
import AddressCard from "./AddressCard";
import CenteredLoader from "./CenteredLoader";

class FranchiseDetails extends React.Component {
  update = input => {
    return this.props.updateFranchise({
      id: this.props.data.franchise.id,
      input
    });
  };

  render() {
    const { data: { loading, error, franchise } } = this.props;
    if (loading) return <CenteredLoader />;
    if (error) return "Error.";
    return (
      <Flex pt={3} wrap>
        <Box w={[1, 1 / 2]} pr={2}>
          <FranchiseInfoCard franchise={franchise} onSave={this.update} />
        </Box>
        <Box w={[1, 1 / 2]} pl={2}>
          <AddressCard
            cardTitle="Address"
            address={franchise.address}
            onSave={values => this.update({ address: values })}
          />
          <AddressCard
            cardTitle="Mailing Address"
            address={franchise.mailingAddress}
            onSave={values => this.update({ mailingAddress: values })}
            mt={3}
          />
        </Box>
      </Flex>
    );
  }
}

const fragments = {
  franchise: gql`
    fragment FranchiseDetailFranchise on Franchise {
      id
      name
      slug
      phone
      email
      assignedInHouseTty
      corporateName
      officeStatus
      franchiseAgreementEffectiveOn
      franchiseAgreementExpiresOn
      onHold
      holdType
      holdReason
      certificationStatus
      chatmeterId
      deactivated
      address {
        id
        streetAddress
        aptNumber
        city
        state
        zipCode
        country
      }
      mailingAddress {
        id
        streetAddress
        aptNumber
        city
        state
        zipCode
        country
      }
    }
  `
};

const FRANCHISE_DETAIL_QUERY = gql`
  query FranchiseDetailQuery($id: ID!) {
    franchise(id: $id) {
      ...FranchiseDetailFranchise
    }
  }
  ${fragments.franchise}
`;

const UPDATE_FRANCHISE_MUTATION = gql`
  mutation UpdateJob($id: ID!, $input: JobInput!) {
    updateFranchise(id: $id, input: $input) {
      ...FranchiseDetailFranchise
    }
  }
  ${fragments.franchise}
`;

const enhance = compose(
  graphql(FRANCHISE_DETAIL_QUERY, {
    options: ({ match: { params: { franchiseId } } }) => ({
      variables: { id: franchiseId }
    })
  }),
  graphql(UPDATE_FRANCHISE_MUTATION, {
    props: ({ mutate }) => ({
      updateFranchise: ({ id, input }) => {
        return mutate({
          variables: { id, input }
        });
      }
    })
  })
);

export default enhance(FranchiseDetails);



// WEBPACK FOOTER //
// ./src/components/FranchiseDetails.js